import React from 'react';
import '../HistoryPage/HistoryPage.css';
function HistoryPage() {
	return (
		<div className='historypage'>
			<div className='title_history'>
				<h1>Історія Коледжу</h1>
			</div>
			<div className='container_all'>
				<div className='tsutata'>
					<img
						src='http://molbuk.ua/uploads/posts/2013-03/1363095587_tehn.jpg'
						alt='Фаховий коледж бізнесу та харчових технологій'
					/>
					<div className='text'>
						Постанова Ради Міністрів України від 23 лютого 1962 року № 204 затвердила
						створення технікуму, який був заснований 6 липня 1964 року на базі школи
						кулінарного учнівства (наказ №296 Міністерства торгівлі УРСР) як
						Чернівецький технікум радянської торгівлі.
					</div>
				</div>

				<div className='pidgotovka'>
					<ul>
						<h2>
							Технікум здійснював підготовку спеціалістів заочної та денної форм
							навчання з таких спеціальностей:
						</h2>
						<li>
							“Товарознавство продовольчих товарів” (товарознавець продовольчих
							товарів).
						</li>
						<li>
							“Товарознавство промислових товарів” (товарознавець промислових
							товарів).
						</li>
						<li>
							“Технологія громадського харчування” (технолог громадського харчування).
						</li>
					</ul>
				</div>

				<div className='else_text'>
					<p>
						{' '}
						<b>Чернівецький державний комерційний технікум</b> є державним вищим
						закладом освіти першого рівня акредитації, який проводить освітню
						діяльність, пов'язану із здобуттям вищої освіти освітньо-кваліфікаційного
						рівня молодшого спеціаліста і має відповідний рівень кадрового та
						матеріально-технічного забезпечення.{' '}
					</p>

					<div className='zavdannya'>
						<h1>Основними завданнями технікуму є :</h1>
						<ol>
							<li>
								Виховання соціально-зрілої, творчої особистості, виховання морально
								і фізично здорового покоління, формування громадянської позиції,
								патріотизму, власної гідності, відповідальності за долю держави,
								суспільства, готовності до трудової діяльності, забезпечення високих
								етичних норм, атмосфери доброзичливості й взаємної поваги у
								стосунках між викладачами та студентами.
							</li>
							<li>
								Забезпечення умов для оволодіння системою знань з обраної
								спеціальності.
							</li>
							<li>Підготовка молоді до самостійної професійної діяльності.</li>
							<li>
								Поєднання гуманітарної освіти з якісною професійною підготовкою.
							</li>
							<li>
								Забезпечення двоступеневої підготовки фахівців за схемою: технікум –
								вуз.
							</li>
							<li>
								Реалізація дуальної системи підготовки фахівців, тобто поєднання
								теоретичної підготовки з практикою.
							</li>
							<li>
								Забезпечення виконання угод з фізичними та юридичними особами на
								підготовку фахівців за освітньо-професійними програмами молодшого
								спеціаліста.
							</li>
							<li>
								Максимально ефективне використання навчального часу шляхом
								впровадження активних форм навчання, інноваційних технологій,
								особистісно-зорієнтованого навчання.
							</li>
							<li>Комп'ютеризація навчального процесу</li>
							<li>Створення чіткої системи контролю за якістю знань.</li>
						</ol>
					</div>
					<div className='text_history'>
						<p>
							Наказом Міністерства торгівлі № 61 від 30.09.91 р. технікум був
							перейменований у Чернівецький державний комерційний технікум. 25 грудня
							1992 року Постановою Кабінету Міністрів України навчальний заклад
							перейшов з відання Міністерства зовнішніх економічних зв'язків і
							торгівлі до функціонального управління Міністерства освіти.
						</p>
						<p>
							З 1964 по 1968 роки технікум знаходився в будинку по вул. Вірменська,
							16. Приміщення було не пристосоване: технікум займав всього 4 аудиторії,
							2 адміністративні кімнати, кімнати для зберігання спортивного інвентарю.
							Заняття проводились у дві зміни. Не дивлячись на недостатню матеріальну
							базу, була чітко визначена мета діяльності: підготовка кваліфікованих
							спеціалістів для торгівлі та громадського харчування.
						</p>
						<p>
							У 1965 році відкрита спеціальність "Бухгалтерський облік". Враховуючи
							потреби народного господарства і економіки, в 1992 – 1997 роках технікум
							випускав фахівців за спеціальністю "Комерційна діяльність". З 1968 року
							технікум почав працювати в новому, побудованому для навчальних цілей,
							приміщенні. Це дало можливість працювати за кабінетною системою. На
							даний час в двох навчальних корпусах технікуму розміщено 35 аудиторій. Є
							кухня-лабораторія, аудиторія-бар (для занять з організації виробництва
							та обслуговування), 2 спортивні зали, їдальня на 250 місць, актова зала
							на 180 місць, бібліотека, читальна зала. У 1989 році побудовано
							9-поверховий гуртожиток з відповідним обладнанням, що дає можливість
							забезпечити житлом всіх бажаючих студентів технікуму.
							<div className='kursuv'>
								<p>
									Наказом Міністерства освіти і науки України № 258 від 20 лютого
									2021 року{' '}
									<b>
										Чернівецький державний комерційний технікум був
										перейменований у Чернівецький фаховий коледж бізнесу та
										харчових технологій.
									</b>
								</p>
							</div>
						</p>

						<p>
							Колеж здійснює підготовку молодших спеціалістів/фахових молодших
							бакалаврів на підставі Відомостей щодо здійснення освітньої діяльності у
							сфері фахової передвищої освіти роздрукованих з сайту МОН України та
							Акту узгодження переліку спеціальностей, за якими здійснюється
							підготовка здобувачів вищої/фахової передвищої освіти за
							освітньо-кваліфікаційним рівнем молодшого спеціаліста/фахового молодшого
							бакалавра та ліцензованого обсягу Чернівецького фахового колежу бізнесу
							та харчових технологій.
						</p>
					</div>
					<div className='book-link-container'>
						<a
							target='__blank'
							href='https://drive.google.com/file/d/1PrTaEA-G9u5ajR30VzYQl0dZ7w3Wfa3e/view?usp=drivesdk'
						>
							<img
								className=''
								src='/IMG-93bb5c7c26cc045e34d204fd5dc8f42e-V.jpg'
								alt=''
							/>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}

export default HistoryPage;
